import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@mui/material';
import React from 'react';
import { IDeleteSSOConfigDialogResult } from 'types/dialogs';

interface IDeleteSSOConfigDialogProps {
	onClose: (res: IDeleteSSOConfigDialogResult) => void;
}

const DeleteSSOConfigDialog: React.FC<IDeleteSSOConfigDialogProps> = ({
	onClose
}) => {
	const cancel = () => onClose({ proceed: false });
	return (
		<Dialog
			open
			maxWidth="sm"
			fullWidth
			PaperProps={{ elevation: 0 }}
			onClose={cancel}
		>
			<DialogTitle>{intl.tr('ssoConfig.delete.dialog.title')}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{intl.tr('ssoConfig.delete.dialog.message')}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
				<Button
					variant="outlined"
					color="error"
					onClick={() => onClose({ proceed: true })}
					data-testid="delete-sso-config-confirm-button"
				>
					{intl.tr('ssoConfig.delete.dialog.confirmButton')}
				</Button>
				<Button
					variant="contained"
					onClick={cancel}
					data-testid="delete-sso-config-cancel-button"
				>
					{intl.tr('ssoConfig.delete.dialog.cancelButton')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteSSOConfigDialog;
